export const drawLinesArticle = {
    id: 'draw-lines',
    title: 'Линии',
    category: 'Режим рисования',
    requiredModule: null,
    sandboxType: null,
    summary: 'Линейные объекты: дороги, проезды, инженерные коммуникации (газ, вода, электричество), заборы, категории и статусы.',
    markdown: `
> **Инструмент «Линии»** предназначен для нанесения линейно-протяжённых объектов: дорожной сети, проездов, заборов и всех типов подземных и надземных инженерных коммуникаций посёлка.

---

## 1. Сценарии использования

:::grid cols=2
:::card icon="road" title="1. Дороги и проезды"
Улицы посёлка, центральные проезды, подъездные пути к участкам, пешеходные тротуары и пожарные проезды.
:::

:::card icon="activity" title="2. Электросети и освещение"
Воздушные и кабельные линии электропередач (ВЛ/КЛ), трассы уличных фонарей, подсветки и слаботочных сетей.
:::

:::card icon="water" title="3. Водопровод, газ и канализация"
Магистральные водопроводные сети, газопроводы высокого и низкого давления, ливневая и бытовая канализация.
:::

:::card icon="shield" title="4. Заборы и ограждения"
Внешний периметральный забор посёлка, фасадные ограждения очередей строительства, шлагбаумные створы и шумозащитные экраны.
:::
:::

---

## 2. Статусы сетей: от проекта до ввода в эксплуатацию

Для инженерных коммуникаций и дорожной инфраструктуры ключевое значение имеет этап реализации:

| Статус | Как выглядит | Что означает |
| :--- | :---: | :--- |
| **В строительстве** | 🏗️ Оранжевый бейдж | **Ключевой статус:** на объекте ведутся активные работы (рытьё траншей, укладка труб/кабелей, отсыпка полотна, асфальтирование). |
| **Запланировано** | 🟡 Жёлтый бейдж | Проектная трасса: перспективный коридор коммуникаций или дорог для будущих очередей посёлка. |
| **На учёте** | ⚪ Без отметки | Действующие сети и дороги, уже введённые в эксплуатацию и находящиеся на балансе. |
| **В продаже** | 🟢 Зелёный бейдж | Применяется для коммерческих линий связи, платных веток или долевых инфраструктурных сетей. |

---

## 3. Категории и цветовое разделение коммуникаций

Чтобы на генеральном плане не путать водопровод с силовым кабелем или газовой трубой, каждой линии назначается **Категория**:

* **Цветовой стандарт:** категории автоматически окрашивают линии в общепринятые цвета (например, газ — *жёлтый*, водоснабжение — *синий*, электричество — *красный/оранжевый*, дороги — *серый*).
* **Тип линии:** для каждой категории можно также выбрать свой тип линии (начертание), чтобы сети разного назначения ещё нагляднее и контрастнее отличались друг от друга на генплане.
* **Паспорт и характеристики:** в карточке линии можно указать собственника, прикрепить исполнительную документацию, схемы прокладки и фото узлов подключения.
`
};
